import { Navigate } from "react-router";
import { Route, Routes } from "react-router-dom";
import AgentCollectionHistoryPage from "../Pages/AgentCollectionHistoryPage";
import AgentPage from "../Pages/AgentPage";
import AgentWalletHistoryPage from "../Pages/AgentWallet HistoryPage";
import AllMemberPage from "../Pages/AllMemberPage";
import DashboardPage from "../Pages/DashboardPage";
import LoginPage from "../Pages/LoginPage";
import MemberLoginPage from "../Pages/MemberLoginPage";
import MyMemberPage from "../Pages/MyMemberPage";
import ReportPage from "../Pages/ReportPage";
import UserSettingPage from "../Pages/UserSettingPage";
import ProtectedRoute from "./Utilities/ProtectedRoute";
import ProtectedMemberPanelRoute from "./Utilities/ProtectedMemberPanelRoute";
import MemberPanelDashboardComponent from "../Component/MemberPanelDashboardComponent/MemberPanelDashboardComponent";
import MemberRequestComponent from "../Component/MemberRequestComponent/MemberRequestComponent";

function AppRoute(props) {
  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate to={"/dashboard"} />} />
        {/* member login */}
        <Route path="/member-login" element={<MemberLoginPage />} />
        <Route
          path="/member-panel"
          element={
            <ProtectedMemberPanelRoute>
              <MemberPanelDashboardComponent />
            </ProtectedMemberPanelRoute>
          }
        />
        {/*login route*/}
        <Route path="/login" element={<LoginPage />} />
        {/*dashboard route*/}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute permissions={["*"]}>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/agent"
          element={
            <ProtectedRoute permissions={["is_admin"]}>
              <AgentPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/all-member"
          element={
            <ProtectedRoute permissions={["is_admin"]}>
              <AllMemberPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/member-requests"
          element={
            <ProtectedRoute permissions={["is_admin"]}>
              <MemberRequestComponent />
            </ProtectedRoute>
          }
        />
        <Route
          path="/report"
          element={
            <ProtectedRoute permissions={["is_admin"]}>
              <ReportPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/agent-history"
          element={
            <ProtectedRoute permissions={["is_admin"]}>
              <AgentWalletHistoryPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/agent-collection-history"
          element={
            <ProtectedRoute permissions={["is_admin"]}>
              <AgentCollectionHistoryPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/my-member"
          element={
            <ProtectedRoute permissions={["*"]}>
              <MyMemberPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/setting"
          element={
            <ProtectedRoute permissions={["*"]}>
              <UserSettingPage />
            </ProtectedRoute>
          }
        />
      </Routes>
    </>
  );
}

export default AppRoute;
